import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectProjectControlItemComponent } from '../selectProjectControlItem/select-project-control-item.component';

@Component({
    standalone: false,
  selector: 'integration-apps-evidence',
  templateUrl: './integration-apps-evidence.component.html',
  styleUrls: ['./integration-apps-evidence.component.css'],
  providers: [DialogService],
})
export class IntegrationAppsEvidenceComponent implements OnInit {
  @Input() settings: any;
  @Input() settingsForm: FormGroup;

  controlsDialogRef: DynamicDialogRef | undefined;

  get control(): string {
    const project = this.settingsForm.get('projectName')?.value ?? '';
    const complianceArea = this.settingsForm.get('complianceArea')?.value ?? '';
    const complianceAreaControlId =
      this.settingsForm.get('complianceAreaControlId')?.value ?? '';

    return `${project} ${complianceAreaControlId} ${complianceArea}`;
  }

  constructor(
    private fb: FormBuilder,
    public dialogRef: DynamicDialogRef,
    public dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.settingsForm.addControl(
      'projectName',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'complianceAreaName',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'complianceAreaControlId',
      this.fb.control('', Validators.required)
    );
    this.settingsForm.addControl(
      'projectId',
      this.fb.control('', Validators.required)
    );

    this.settingsForm.patchValue(this.settings);
  }

  addControl() {
    this.controlsDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      {
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10010,
        maximizable: true,
        data: {},
        header: 'Select control',
      }
    );

    this.controlsDialogRef.onClose.subscribe((data: any) => {
      if (data) {
        const value = {
          complianceAreaControlId: data.controlItem.complianceAreaControlId,
          complianceAreaName: data.controlItem.complianceAreaName,
          projectId: data.projectId,
          projectName: data.projectName,
        };

        this.settingsForm.patchValue(value);
      }
    });
  }
}
